import { FC } from 'react';

import { PriceEnhancerRaw } from './PriceEnhancerRaw';
import type { PriceEnhancerRawProps } from './PriceEnhancerRaw.connect';
import { connectPriceEnhancerRaw } from './PriceEnhancerRaw.connect';
import { ConnectedPriceImprovementRaw } from './priceImprovement/PriceImprovement.connect';
export const PriceEnhancerWithNegotiationRaw: FC<PriceEnhancerRawProps> = ({
  tabId,
  quoteId,
  issuePrice,
  xMargin,
  tradingOffer,
  mode,
  sponso,
  sponsoUpFront,
  topUpUpFront,
  yMarginRetrocession,
  displaySponsoFields,
  onFieldValueChanged,
  onSponsoFeeFieldValueChanged,
}) => {
  return (
    <>
      <PriceEnhancerRaw
        issuePrice={issuePrice}
        xMargin={xMargin}
        tradingOffer={tradingOffer}
        mode={mode}
        sponso={sponso}
        sponsoUpFront={sponsoUpFront}
        topUpUpFront={topUpUpFront}
        yMarginRetrocession={yMarginRetrocession}
        displaySponsoFields={displaySponsoFields}
        onFieldValueChanged={onFieldValueChanged}
        onSponsoFeeFieldValueChanged={onSponsoFeeFieldValueChanged}
      />
      <ConnectedPriceImprovementRaw
        tabId={tabId}
        quoteId={quoteId}
        key={tabId}
        onFieldValueChanged={onFieldValueChanged}
      />
    </>
  );
};

export const PriceEnhancerWithNegotiation = connectPriceEnhancerRaw(PriceEnhancerWithNegotiationRaw);

PriceEnhancerWithNegotiation.displayName = 'PriceEnhancerWithNegotiation';
